import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { STiRResultListPO, SeedConversionSavePO, SeedConversionDeletePO } from "../models";
import { AppConstants } from "../shared/constants";

@Injectable({
    providedIn: "root",
})
export class SeedConversionService {

    constructor(private baseService: BaseService) { }

    GetSeedConversion(): Observable<STiRResultListPO<SeedConversionSavePO>> {
        let url = "Admin/GetSeedConversion";
        return this.baseService.Get(url, AppConstants.Loading);
    }

    UpsertSeedConversion(data: SeedConversionSavePO[]): Observable<STiRResultListPO<SeedConversionSavePO>> {
        let url = `Admin/UpsertSeedConversion`;
        return this.baseService.Post(url, data, AppConstants.Saving);
    }

    DeleteSeedConversion(data: SeedConversionDeletePO): Observable<STiRResultListPO<SeedConversionSavePO>> {
        let url = "Admin/DeleteSeedConversion";
        return this.baseService.Post(url, data, AppConstants.Loading);
    }
}